var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidepanel',{attrs:{"id":"select-marker","title":"Select marker","processing":_vm.processing}},_vm._l((_vm.markers),function(marker,key){return _c('div',{key:marker.id,staticClass:"marker-option",class:{ disabled: _vm.selectedMarkers.find(function (marker) { return marker.id === key; }) },on:{"click":function($event){return _vm.selectMarker({
        id: key,
        title: marker.name,
        type: marker.type,
        unit: marker.unit,
        value: null
      })}}},[_vm._v(" "+_vm._s(marker.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }